"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quantity = void 0;
const react_1 = __importStar(require("react"));
const select_1 = require("../select");
const styles_1 = require("./styles");
const Quantity = (props) => {
    const { displayString, setQuantity, maxOrderQuantity, minOrderQuantity } = props;
    const options = (0, react_1.useMemo)(() => createOptionsArray(maxOrderQuantity), [maxOrderQuantity]);
    const handleQuantityChange = (option) => __awaiter(void 0, void 0, void 0, function* () {
        if (setQuantity) {
            setQuantity(Number.parseInt(option.value));
        }
    });
    return maxOrderQuantity != undefined && maxOrderQuantity > 1 ? (react_1.default.createElement(styles_1.StyledQuantity, null,
        react_1.default.createElement(select_1.SingleSelector, { renderPrefix: true, ariaLabel: displayString, options: options, defaultOption: options.find((opt) => opt.value === (minOrderQuantity === null || minOrderQuantity === void 0 ? void 0 : minOrderQuantity.toString())), dataCyPrefix: "quantity", size: "regular", menuMaxHeight: 300, onChangeHook: handleQuantityChange }))) : null;
};
exports.Quantity = Quantity;
const createOptionsArray = (maxQuantity) => {
    const tempOptionsArray = new Array(maxQuantity).fill(null).map((_, i) => i + 1);
    return tempOptionsArray.map((qty) => ({
        label: qty.toString(),
        value: qty.toString()
    }));
};
